import React from "react";
import ProgressBar from "react-animated-progress-bar";

class About extends React.Component {
  render() {
    return (
      <section id="about" className="about">
        <div className="about-me container">
          <div className="section-title">
            <h2>About</h2>
            <p>Learn more about me</p>
          </div>

          <div className="row">
            <div className="col-lg-4" data-aos="fade-right">
              <img src="assets/img/Me1.jpg" className="img-fluid" alt="" />
            </div>
          <div className="col-lg-8 pt-4 pt-lg-0 content" data-aos="fade-left">
              <h3>Senior Software Engineer | Full Stack Developer | Linux & Infrastructure Engineer</h3>
              <p className="font-italic text-justify">
                Proactive Full Stack Developer with 4+ years of experience building, 
                deploying, and optimizing modern web applications and enterprise IT 
                infrastructure. Expert in React, Next.js, PHP (Laravel), and ASP.NET, 
                with strong proficiency in Linux server administration, Apache web server 
                configuration, MySQL/PostgreSQL database optimization, and CI/CD pipeline 
                implementation.
              </p>
              <p className="font-italic text-justify">
                Skilled in end-to-end application deployment, DNS management, SSL 
                certificate configuration, Cloudflare integration, and website performance 
                optimization including Core Web Vitals and technical SEO. Proven ability 
                to automate workflows, implement AI-powered solutions, and manage 
                infrastructure across enterprise-scale environments serving 10+ 
                mission-critical healthcare applications.
              </p>
              <p className="font-italic text-justify">
                Demonstrated success in application migration projects, database 
                optimization, and production support with 700+ service requests and 
                300+ incidents resolved. Strong analytical thinking and technical 
                decision-making skills with a proactive mindset to drive digital growth 
                and operational efficiency through modern DevOps practices.
              </p>
              <div className="row">
                <div className="col-lg-6">
                  <ul>
                    <li>
                      <i className="icofont-rounded-right"></i>{" "}
                      <strong>Email:</strong> mawsa3454@gmail.com
                    </li>
                    <li>
                      <i className="icofont-rounded-right"></i>{" "}
                      <strong>Phone:</strong> +94 75 680 0099
                    </li>
                    <li>
                      <i className="icofont-rounded-right"></i>{" "}
                      <strong>Location:</strong> Batticaloa, Sri Lanka
                    </li>
                  </ul>
                </div>
                <div className="col-lg-6">
                  <ul>
                    <li>
                      <i className="icofont-rounded-right"></i>{" "}
                      <strong>Degree:</strong> BEng (Hons) Software Engineering
                    </li>
                    <li>
                      <i className="icofont-rounded-right"></i>{" "}
                      <strong>University:</strong> London Metropolitan University, UK
                    </li>
                    <li>
                      <i className="icofont-rounded-right"></i>{" "}
                      <strong>Current Role:</strong> Senior Software Engineer at HCLTech
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="counts container">
    
                    <div className="row">
    
                        <div className="col-lg-3 col-md-6">
                            <div className="count-box">
                                <i className="icofont-simple-smile"></i>
                                <React.Fragment>
                                    <CountUp start={0} end={100}  duration="2">

                                        {({ countUpRef, start }) => (
                                            <VisibilitySensor onChange={start} delayedCall>
                                                <span ref={countUpRef} />
                                            </VisibilitySensor>
                                        )}

                                    </CountUp>
                                </React.Fragment>
                                <p>Happy Clients</p>
                            </div>
                        </div>
    
                        <div className="col-lg-3 col-md-6 mt-5 mt-md-0">
                            <div className="count-box">
                                <i className="icofont-document-folder"></i>
                                <React.Fragment>
                                    <CountUp start={0} end={120}  duration="2">

                                        {({ countUpRef, start }) => (
                                            <VisibilitySensor onChange={start} delayedCall>
                                                <span ref={countUpRef} />
                                            </VisibilitySensor>
                                        )}

                                    </CountUp>
                                </React.Fragment>
                                <p>Projects</p>
                            </div>
                        </div>
    
                        <div className="col-lg-3 col-md-6 mt-5 mt-lg-0">
                            <div className="count-box">
                                <i className="icofont-live-support"></i>
                                <React.Fragment>
                                    <CountUp start={0} end={125}  duration="2">

                                        {({ countUpRef, start }) => (
                                            <VisibilitySensor onChange={start} delayedCall>
                                                <span ref={countUpRef} />
                                            </VisibilitySensor>
                                        )}

                                    </CountUp>
                                </React.Fragment>
                                <p>Hours Of Support</p>
                            </div>
                        </div>
    
                        <div className="col-lg-3 col-md-6 mt-5 mt-lg-0">
                            <div className="count-box">
                                <i className="icofont-users-alt-5"></i>
                                <React.Fragment>
                                    <CountUp start={0} end={5}  duration="2">

                                        {({ countUpRef, start }) => (
                                            <VisibilitySensor onChange={start} delayedCall>
                                                <span ref={countUpRef} />
                                            </VisibilitySensor>
                                        )}

                                    </CountUp>
                                </React.Fragment>
                                <p>Hard Workers</p>
                            </div>
                        </div>
    
                    </div>
    
                </div> */}

        <div className="skills container">
          <div className="section-title">
            <h2>Skills</h2>
          </div>
          <div className="row skills-content">
            <div className="col-lg-6">
              <div className="progress">
                <span className="skill">Full Stack Development (React, Next.js, PHP, ASP.NET)</span>
                <ProgressBar
                  width="100%"
                  height="10px"
                  rect
                  percentage="90"
                  rectBorderRadius="30px"
                  bgColor="#18a7d2"
                />
              </div>

              <div className="progress">
                <span className="skill">Linux Server Administration & Apache Configuration</span>
                <ProgressBar
                  width="100%"
                  height="10px"
                  rect
                  percentage="90"
                  rectBorderRadius="30px"
                  bgColor="#18a7d2"
                />
              </div>

              <div className="progress">
                <span className="skill">CI/CD Pipelines & DevOps Practices</span>
                <ProgressBar
                  width="100%"
                  height="10px"
                  rect
                  percentage="85"
                  rectBorderRadius="30px"
                  bgColor="#18a7d2"
                />
              </div>

              <div className="progress">
                <span className="skill">Application Deployment & Hosting Management</span>
                <ProgressBar
                  width="100%"
                  height="10px"
                  rect
                  percentage="85"
                  rectBorderRadius="30px"
                  bgColor="#18a7d2"
                />
              </div>

              <div className="progress">
                <span className="skill">MySQL / PostgreSQL Database Optimization</span>
                <ProgressBar
                  width="100%"
                  height="10px"
                  rect
                  percentage="85"
                  rectBorderRadius="30px"
                  bgColor="#18a7d2"
                />
              </div>

              <div className="progress">
                <span className="skill">DNS, SSL & Cloudflare Management</span>
                <ProgressBar
                  width="100%"
                  height="10px"
                  rect
                  percentage="80"
                  rectBorderRadius="30px"
                  bgColor="#18a7d2"
                />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="progress">
                <span className="skill">Website Performance & Core Web Vitals Optimization</span>
                <ProgressBar
                  width="100%"
                  height="10px"
                  rect
                  percentage="85"
                  rectBorderRadius="30px"
                  bgColor="#18a7d2"
                />
              </div>

              <div className="progress">
                <span className="skill">Technical SEO & Page Speed Optimization</span>
                <ProgressBar
                  width="100%"
                  height="10px"
                  rect
                  percentage="80"
                  rectBorderRadius="30px"
                  bgColor="#18a7d2"
                />
              </div>

              <div className="progress">
                <span className="skill">AI-Powered Solutions & Workflow Automation</span>
                <ProgressBar
                  width="100%"
                  height="10px"
                  rect
                  percentage="80"
                  rectBorderRadius="30px"
                  bgColor="#18a7d2"
                />
              </div>

              <div className="progress">
                <span className="skill">REST APIs & Enterprise Application Development</span>
                <ProgressBar
                  width="100%"
                  height="10px"
                  rect
                  percentage="85"
                  rectBorderRadius="30px"
                  bgColor="#18a7d2"
                />
              </div>

              <div className="progress">
                <span className="skill">Git, GitHub & Version Control</span>
                <ProgressBar
                  width="100%"
                  height="10px"
                  rect
                  percentage="85"
                  rectBorderRadius="30px"
                  bgColor="#18a7d2"
                />
              </div>

              <div className="progress">
                <span className="skill">Infrastructure Management & System Administration</span>
                <ProgressBar
                  width="100%"
                  height="10px"
                  rect
                  percentage="90"
                  rectBorderRadius="30px"
                  bgColor="#18a7d2"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="interests container">
          <div className="section-title">
            <h2>Interests</h2>
          </div>

          <div className="row">
            <div className="col-lg-3 col-md-4">
              <div className="icon-box">
                <i
                  className="ri-layout-6-line"
                  style={{ color: "#ffbb2c" }}
                ></i>
                <h3>Web Designing</h3>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 mt-4 mt-md-0">
              <div className="icon-box">
                <i
                  className="ri-code-box-line"
                  style={{ color: "#5578ff" }}
                ></i>
                <h3>Web Development</h3>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 mt-4 mt-md-0">
              <div className="icon-box">
                <i className="ri-gamepad-line" style={{ color: "#e80368" }}></i>
                <h3>Gaming</h3>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 mt-4 mt-lg-0">
              <div className="icon-box">
                <i className="ri-riding-fill" style={{ color: "#e361ff" }}></i>
                <h3>Travelling</h3>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 mt-4">
              <div className="icon-box">
                <i className="ri-book-line" style={{ color: "#47aeff" }}></i>
                <h3>Books</h3>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 mt-4">
              <div className="icon-box">
                <i className="ri-cup-line" style={{ color: "#ffa76e" }}></i>
                <h3>Coffee</h3>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 mt-4">
              <div className="icon-box">
                <i className="ri-bug-line" style={{ color: "#11dbcf" }}></i>
                <h3>Debugging</h3>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 mt-4">
              <div className="icon-box">
                <i
                  className="ri-ancient-pavilion-line"
                  style={{ color: "#4233ff" }}
                ></i>
                <h3>Camping</h3>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 mt-4">
              <div className="icon-box">
                <i className="ri-run-fill" style={{ color: "#b2904f" }}></i>
                <h3>Athelete</h3>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 mt-4">
              <div className="icon-box">
                <i
                  className="ri-basketball-line"
                  style={{ color: "#b20969" }}
                ></i>
                <h3>Volley Ball</h3>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 mt-4">
              <div className="icon-box">
                <i
                  className="ri-camera-3-line"
                  style={{ color: "#ff5828" }}
                ></i>
                <h3>Photography</h3>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 mt-4">
              <div className="icon-box">
                <i className="ri-tv-2-line" style={{ color: "#29cc61;" }}></i>
                <h3>Netflix</h3>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default About;
